<template>
    <section
        v-if="content"
        class="c-referral-how-it-works"
    >
        <div class="c-referral-how-it-works__first-section">
            <div class="title-container">
                <h2 class="title">
                    {{ content.title }}
                </h2>
                <div class="semi-circle">
                    <div class="circle-1" />
                    <div class="circle-2" />
                    <div class="circle-3" />
                </div>
            </div>
            <div class="action">
                <y-button
                    v-if="!buttonClass"
                    color="primary"
                    :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                    :to="content.custom['button-link']"
                    :href="content.custom['button-link']"
                >
                    {{ content.custom['button-title'] }}
                </y-button>
                <y-button
                    v-else
                    :class="{[buttonClass]: !!buttonClass}"
                    color="primary"
                >
                    {{ content.custom['button-title'] }}
                </y-button>
            </div>
        </div>
        <div class="c-referral-how-it-works__second-section">
            <div class="cards-container">
                <div
                    v-for="item,index in content.album"
                    :key="item.id"
                    class="cards-container__card"
                >
                    <div class="image">
                        <img
                            :src="imgSrc(item)"
                            :alt="item.title"
                        >
                    </div>
                    <div class="title">
                        <h3 class="text">
                            {{ item.title }}
                        </h3>
                        <span class="index">
                            {{ digits(`0${index+1}`, $i18n.locale) }}
                        </span>
                    </div>
                    <component
                        :is="'p'"
                        class="description"
                        v-html="textReplacer(item.description,'description__highlight')"
                    />
                    <div
                        v-if="index===2"
                        class="additional-info"
                    >
                        <img
                            src="@/assets/images/info-circle.svg"
                            alt=""
                            class="additional-info__icon"
                        >
                        <p class="additional-info__note">
                            {{ content.note }}
                        </p>
                    </div>
                </div>
            </div>

            <div class="action">
                <y-button
                    v-if="!buttonClass"
                    color="primary"
                    :tag="isLink(content.custom['button-link']) ? 'a' : 'router-link'"
                    :to="content.custom['button-link']"
                    :href="content.custom['button-link']"
                >
                    {{ content.custom['button-title'] }}
                </y-button>
                <y-button
                    v-else
                    :class="{[buttonClass]: !!buttonClass}"
                    color="primary"
                >
                    {{ content.custom['button-title'] }}
                </y-button>
            </div>
        </div>
    </section>
</template>

<script>
    import { isLink, textReplacer } from '@/helpers/helpers';
    import { digits } from '@groot-nodes/helpers/number';

    export default {
        name: 'HowReferralWorks',

        props: {
            content    : Object,
            buttonClass: String,
        },
        methods: {
            isLink,
            digits,
            textReplacer,
        },
    };
</script>

<style lang="scss" src="./index.scss"></style>
